import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class Buttons {
	static init() {
		this.buttons = document.querySelectorAll(".btn, .btn-pebble, .btn-light");

		this.buttons.forEach( (button) => {

			if( button.classList.contains('btn-share') || button.classList.contains('gform_button') ){
				return;
			}

			const initialText = button.innerHTML;
			const text = document.createElement("span");
			text.classList.add('label');
			text.setAttribute('data-text', initialText.replace(/&nbsp;/g, '\u00A0'));
			text.innerHTML = initialText;
			button.innerHTML = "";
			button.prepend(text);

			if( button.classList.contains('btn-pebble') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="78" height="70" viewBox="0 0 78 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M38.8873 0.080491C44.2632 0.0804908 49.6692 0.293234 55.0452 0.0196898C58.7298 -0.162673 61.2063 0.901115 63.3809 4.06207C67.6091 10.2016 72.3809 15.9765 76.6998 22.0856C77.636 23.4229 78.2401 25.6113 77.9079 27.1917C76.0354 36.401 73.9816 45.5496 71.6561 54.6373C71.2635 56.1874 69.4816 58.1326 67.9413 58.5581C54.4109 62.4485 40.79 66.0046 27.2294 69.743C24.8133 70.4117 23.575 69.8038 22.3971 67.5851C15.0883 53.6343 7.59826 39.8052 0.41025 25.824C-0.28439 24.4563 -0.0729502 21.7512 0.863303 20.5355C5.42376 14.4263 10.256 8.49957 15.2997 2.78554C16.5682 1.35703 18.9239 0.323622 20.8568 0.202047C26.867 -0.132285 32.8771 0.0804913 38.8873 0.080491Z" fill="#FFDFD6"/>
				</svg>`;
				element.classList.add('pebble');
				button.prepend(element);
			}

			if( button.classList.contains('btn-go') || button.classList.contains('btn-back') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.89551 7.5H17.8955M17.8955 7.5L11.8955 1.5M17.8955 7.5L11.8955 13.5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-download') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.51223 5.64288L0.5 6.63552L7.5 13.5L14.5 6.63552L13.488 5.64288L8.21598 10.8129L8.21598 0.5L6.78441 0.5L6.78441 10.8129L1.51223 5.64288Z"/>
<path d="M2 15H13V16H2V15Z"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-gallery') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="17" height="14" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4 1H16V10M1 4H13V13H1V4Z" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

			if( button.classList.contains('btn-lang') ){
				const element = document.createElement("span");
				element.innerHTML = `<svg width="15" height="10" viewBox="0 0 15 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.08786 0.982932L8.15892 8.054L7.07107 9.14186L0 2.07079L1.08786 0.982932Z" fill="#34847A"/>
<path d="M14.1422 2.07077L7.07107 9.14186L5.98332 8.05398L13.0544 0.98291L14.1422 2.07077Z" fill="#34847A"/>
</svg>`;
				element.classList.add('svg');
				button.appendChild(element);
			}

		});

		document.addEventListener("mousemove", e => {
			this.magneticButton(e);
		});

	}

	static magneticButton(e){

		this.cursorPosition = {
			left: e.clientX,
			top: e.clientY
		};

		document.querySelectorAll(".magnetic-link").forEach((single) => {
			const triggerDistance = single.getBoundingClientRect().width;

			const targetPosition = {
				left:
					single.getBoundingClientRect().left +
					single.getBoundingClientRect().width / 2,
				top:
					single.getBoundingClientRect().top +
					single.getBoundingClientRect().height / 2
			};

			const distance = {
				x: targetPosition.left - this.cursorPosition.left,
				y: targetPosition.top - this.cursorPosition.top
			};

			const angle = Math.atan2(distance.x, distance.y);
			const hypotenuse = Math.sqrt(
				distance.x * distance.x + distance.y * distance.y
			);

			const quickX = gsap.quickTo(single, "x", { duration: 0.3, ease: "power2.out" });
			const quickY = gsap.quickTo(single, "y", { duration: 0.3, ease: "power2.out" });

			if (hypotenuse < triggerDistance) {
				quickX(-((Math.sin(angle) * hypotenuse) / 2));
				quickY(-((Math.cos(angle) * hypotenuse) / 2));
			} else {
				quickX(0);
				quickY(0);
			}
		});

	}

}
